import React from 'react';
import debounce from 'debounce';

import './SCITellUsMore.scss';
const ns = 'service-text-box';

type Props = {
  intl: Object,
  updateAdditionalServicesNotes: (notes: string) => void,
  additionalServicesNotes: string
};

const SCITellUsMore = ({
  intl,
  updateAdditionalServicesNotes,
  additionalServicesNotes
}: Props) => {
  const textareaChange = debounce(
    text => updateAdditionalServicesNotes(text),
    400
  );
  return (
    <div className={ns}>
      <div className={`${ns}__label ${ns}__label--sci`}>
        {intl.formatMessage({
          id: 'c8.self.check.in.edit.services.page.tellusmore.label',
          defaultMessage: `Don't see what you're looking for?`
        })}
      </div>
      <textarea
        className={`${ns}__tell-us-more ${ns}__tell-us-more--sci`}
        onChange={ev => textareaChange(ev.target.value)}
        placeholder={intl.formatMessage({
          id: 'c8.self.check.in.edit.services.page.tellusmore.placeholder',
          defaultMessage: `Describe your service needs or add additional details`
        })}
        defaultValue={additionalServicesNotes}
        id="tellus_more_texbox"
        aria-label={intl.formatMessage({
          id: 'c8.aria.type.in.more.info',
          defaultMessage: 'Type In More Information'
        })}
        tabIndex={0}
      />
    </div>
  );
};

export default SCITellUsMore;



// WEBPACK FOOTER //
// ./src/components/atoms/SCITellUsMore/SCITellUsMore.js